<script>
	import { mapActions, mapGetters } from 'vuex';

	export default {
		name: 'OnboardingCompletionButton',
		computed: {
			...mapGetters({
				isInitialized: 'onboardingModule/isInitialized',
				numStages: 'onboardingModule/numStages',
				numCompleted: 'onboardingModule/numCompleted',
				numPending: 'onboardingModule/numPending',
			})
		},
		methods: {
			...mapActions({
				initializeOnboarding: 'onboardingModule/get'
			}),
			handleClick() {
				this.$router.push({ name: 'accountSetup' })
			}
		},
		async created() {
			if (!this.isInitialized) {
				await this.initializeOnboarding();
			}
		}
	};
</script>

<template>
	<v-btn
		v-if="numPending > 0"
		color="#90CA92" class="text--primary"
		depressed
		@click="handleClick">
		<span>Account Setup {{ numCompleted }} / {{ numStages }} </span>
		<v-icon right>done_all</v-icon>
	</v-btn>
</template>

<style>
	#sideNavOnboardingBtn {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}
</style>